import Section from "@bmi-digital/components/section";
import { styled } from "@mui/material/styles";

export const StyledSectionTitle = styled(Section.Title)(({ theme }) => ({
  marginBottom: "30px"
}));

export const StyledSectionDescription = styled("div")(({ theme }) => ({
  marginBottom: "30px"
}));
